(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shoppable-video-embeds"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.video-list').forEach(function (elem) {
      elem.querySelectorAll('.video-card').forEach(function (card) {
        card.querySelector('.video-sound-btn').addEventListener('click', function (e) {
          e.preventDefault();
          let videoElement = card.getElementsByTagName('video')[0];
          if (card.classList.contains('muted')) {
            videoElement.muted = true;
          } else {
            videoElement.muted = false;
          }
          card.classList.toggle('muted');
        });
      });

      new Swiper(elem, {
        slidesPerView: '4',
        spaceBetween: 16,
        loop: false,
        mousewheel: { forceToAxis: true },
        pagination: {
          el: elem.querySelector('.swiper-pagination'),
        },
        navigation: {
          nextEl: elem.querySelector('.swiper-btn-next'),
          prevEl: elem.querySelector('.swiper-btn-prev'),
        },
        breakpoints: {
          1280: {
            // large desktops
            slidesPerView: 4,
            spaceBetween: 16,
            centeredSlides: false,
          },
          1024: {
            // tablets and small laptops
            slidesPerView: 3,
            spaceBetween: 16,
            centeredSlides: false,
          },
          768: {
            // landscape tablets and large phones
            slidesPerView: 2,
            spaceBetween: 12,
            centeredSlides: false,
          },
          480: {
            // mobile devices
            slidesPerView: 1.2,
            spaceBetween: 10,
            centeredSlides: true,
          },
          320: {
            // mobile devices
            slidesPerView: 1.2,
            spaceBetween: 10,
            centeredSlides: true,
          },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
